<ion-card>
    <ion-card-content>
        <ion-input [(ngModel)]="gridRef" expand="full" placeholder="Grid Ref"></ion-input>
    </ion-card-content>
</ion-card>
